"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { ThemeVariant } from "@/types";
import { EventSeries } from "@/types/event";
import { Carousel } from "../ui/carousel/carousel";
import { useState } from "react";
import { ChipFilterGroup } from "../ui/ChipFilterGroup";
import { NewsCard } from "../ui/cards";
export interface EventSeriesListProps {
  series: EventSeries[];
  variant?: ThemeVariant;
  className?: string;
}
export const EventSeriesList: React.FC<EventSeriesListProps> = t0 => {
  const $ = _c(39);
  const {
    series,
    variant,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const [randomNumber] = useState(_temp);
  const [seenSeries, setSeenSeries] = useState(series);
  let t2;
  if ($[0] !== randomNumber || $[1] !== series) {
    t2 = () => series[Math.floor(randomNumber * series.length)];
    $[0] = randomNumber;
    $[1] = series;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [activeSeries, setActiveSeries] = useState(t2);
  if (series !== seenSeries) {
    setSeenSeries(series);
    const departmentIndex = Math.floor(randomNumber * seenSeries.length);
    setActiveSeries(seenSeries.length ? seenSeries[departmentIndex] : null);
  }
  if (!activeSeries) {
    return;
  }
  let t3;
  if ($[3] !== className) {
    t3 = cn("container", className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== seenSeries) {
    t4 = seenSeries.map(_temp2).join(",");
    $[5] = seenSeries;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== series) {
    t5 = series.map(_temp3);
    $[7] = series;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== activeSeries.id) {
    t6 = [activeSeries.id];
    $[9] = activeSeries.id;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== seenSeries) {
    t7 = tags => setActiveSeries(seenSeries.find(seriesItem_1 => seriesItem_1.id === tags[0]) ?? null);
    $[11] = seenSeries;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== variant) {
    t8 = <ChipFilterGroup key={t4} variant={variant} tags={t5} searchParamName="event-filter" canSelectNone={false} defaultActiveTags={t6} onChange={t7} />;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = variant;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t3 || $[20] !== t8) {
    t9 = <div className={t3}>{t8}</div>;
    $[19] = t3;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== className) {
    t10 = cn("container mt-2", className);
    $[22] = className;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== activeSeries.events || $[25] !== variant) {
    let t12;
    if ($[27] !== variant) {
      t12 = event => <NewsCard className="relative h-full overflow-hidden" key={event.id} align="top" icon="fire" label="MUUUH! Event-Reihe" headline={event.name} href={event.link?.href} target={event.link?.target} image={event.image} variant={variant} />;
      $[27] = variant;
      $[28] = t12;
    } else {
      t12 = $[28];
    }
    t11 = activeSeries.events.map(t12);
    $[24] = activeSeries.events;
    $[25] = variant;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      align: "start",
      loop: false,
      dragFree: true
    };
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t11 || $[31] !== variant) {
    t13 = <Carousel items={t11} showArrows={true} overflowVisible={true} arrowPosition="bottom" opts={t12} className="col-span-full" itemClassName="h-60 md:h-96 lg:h-[34rem]" variant={variant} />;
    $[30] = t11;
    $[31] = variant;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t10 || $[34] !== t13) {
    t14 = <div className="overflow-hidden"><div className={t10}>{t13}</div></div>;
    $[33] = t10;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t14 || $[37] !== t9) {
    t15 = <div className="">{t9}{t14}</div>;
    $[36] = t14;
    $[37] = t9;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
};
function _temp() {
  return Math.random();
}
function _temp2(seriesItem) {
  return seriesItem.id;
}
function _temp3(seriesItem_0) {
  return {
    label: seriesItem_0.name,
    id: seriesItem_0.id
  };
}